import React from 'react';
import SEO from './SEO';

const Step = ({ number, title, desc, color }) => (
  <div className="text-center p-8 bg-gray-light rounded-2xl hover:-translate-y-2 transition-all duration-300 hover:shadow-lg group">
    <div className={`w-16 h-16 ${color} rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold text-white group-hover:scale-110 transition-transform duration-300`}>
      {number}
    </div>
    <h4 className="text-xl font-bold text-dark mb-4">{title}</h4>
    <p className="text-gray leading-relaxed">{desc}</p>
  </div>
);

const OurProcess = () => {
  return (
    <div className="services">
      <SEO
        title="Our Process | CoreNova Renewable Energy"
        description="Consultation, design, installation, and ongoing support to deliver exceptional renewable energy solutions."
        canonical="https://corenovarenewable.com/services/process"
        keywords="process, consultation, design, installation, support"
      />

      <section className="relative bg-gradient-to-r from-primary-green to-secondary-blue text-white py-20 lg:py-32 text-center overflow-hidden">
        <div className="absolute inset-0">
          <img src="/images/service hero.png" alt="Our Process" className="w-full h-full object-cover opacity-60" />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-green/40 to-secondary-blue/40"></div>
        </div>
        <div className="container relative z-10">
          <h1 className="text-4xl md:text-6xl font-bold">Our Process</h1>
          <p className="text-xl md:text-2xl opacity-90">From idea to operation—done right</p>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Step number={1} title="Consultation" desc="Initial assessment and energy audit to understand your needs and goals." color="bg-gradient-to-r from-primary-green to-primary-green-light" />
            <Step number={2} title="Design" desc="Custom system design optimized for your location and energy requirements." color="bg-gradient-to-r from-secondary-blue to-secondary-blue-dark" />
            <Step number={3} title="Installation" desc="Professional installation by certified technicians with quality assurance." color="bg-gradient-to-r from-primary-green to-secondary-blue" />
            <Step number={4} title="Support" desc="Ongoing maintenance, monitoring, and support to ensure optimal performance." color="bg-gradient-to-r from-primary-green to-primary-green-light" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurProcess; 